import React from 'react';
import clsx from 'clsx';

import styles from './Input.module.scss';

export type InputProps = JSX.IntrinsicElements['input'] & {
  className?: string;
  type?: 'text' | 'password' | 'search' | 'radio';
  hasError?: boolean;
  isDisabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: string;
};

export const Input: React.FC<InputProps> = ({
  type = 'text',
  className,
  hasError,
  value = '',
  placeholder = '',
  onChange,
  isDisabled,
  prefix,
  ...input
}) => {
  const change = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  return (
    <input
      className={clsx(styles.root, { [styles['have-error']]: hasError }, className)}
      type={type}
      placeholder={placeholder}
      onChange={change}
      value={value}
      disabled={isDisabled}
      {...input}
    />
  );
};

export const Textarea: React.FC<any> = ({
  type = 'text',
  className,
  hasError,
  value = '',
  placeholder = '',
  onChange,
  isDisabled,
  ...input
}) => {
  const change = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  return (
    <textarea
      className={clsx(styles.root, { [styles['have-error']]: hasError }, className)}
      placeholder={placeholder}
      onChange={change}
      value={value}
      disabled={isDisabled}
      {...input}
    />
  );
};
